module.exports = __webpack_public_path__ + "img/9.7ef369f3.jpg";